import _lib from '../_lib';
import active from './active/index';
import {CurrentNurseNavigation} from '@/store/modules/fsm/messages';

export default ({tree,parent,api}) => {
  let regionName = 'nurses';
  let activations = [
    {
      name: 'nurses',
      test: api.messageIs(CurrentNurseNavigation)
    }
  ];
  let activeIndex = active;
  let func = _lib({regionName,activations,activeIndex});
  return func({tree,parent,api});
};